import React from 'react';
import PropTypes from 'prop-types';

import { withStyles, Checkbox, FormControlLabel, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { Controller } from 'react-hook-form';
import { categoryDetailsModalStyles } from '../styles';
import { getLocationItem } from '../../../collums-constants/utils';

const forStaffOptions = [
    { name: 'Sell this service', id: 'SELL' },
    { name: 'Perform this service', id: 'PERFORM' },
    { name: 'Perform AND sell this service', id: 'BOTH' }
];

function CommissionTab({ category, classes, watch, control, clinic, isFromOrg, setValue }) {
    const allowCommissionWatch = watch('allowCommission');

    const defaultCommissionCondition = category?.id
        ? isFromOrg
            ? category.commissionCondition
            : getLocationItem(category, clinic).commissionCondition
        : null;

    return (
        <div className={classes.formContent}>
            <Controller
                name="allowCommission"
                control={control}
                defaultValue={
                    category?.id
                        ? isFromOrg
                            ? category.allowCommission
                            : getLocationItem(category, clinic).allowCommission
                        : false
                }
                render={({ value, onChange }) => (
                    <FormControlLabel
                        label="Allow commission"
                        control={
                            <Checkbox
                                checked={!!value}
                                onChange={e => {
                                    const checked = e.target.checked;
                                    onChange(checked);

                                    if (checked) {
                                        setValue('commissionCondition', forStaffOptions[0].id);
                                    } else {
                                        setValue('commissionCondition', null);
                                    }
                                }}
                            />
                        }
                    />
                )}
            />

            {allowCommissionWatch && (
                <div className={classes.formContentRow}>
                    <FormControl className={classes.formItem} variant="outlined">
                        <InputLabel>For Staff that</InputLabel>
                        <Controller
                            name="commissionCondition"
                            control={control}
                            defaultValue={defaultCommissionCondition || forStaffOptions[0].id}
                            render={({ value, onChange }) => (
                                <Select value={value ?? ''} onChange={e => onChange(e.target.value)}>
                                    {forStaffOptions.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                </div>
            )}
        </div>
    );
}

CommissionTab.propTypes = {
    classes: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    category: PropTypes.object,
    setValue: PropTypes.func.isRequired
};

export default withStyles(categoryDetailsModalStyles)(CommissionTab);
